export enum OrderStatusType {
  AWAITING = 'AWAITING',
  PRE_APPROVED = 'PRE_APPROVED',
  REFUSED = 'REFUSED',
}

export const OrderStatusTypeColor = {
  [OrderStatusType.REFUSED]: '#DB0032',
  [OrderStatusType.PRE_APPROVED]: '#A2D45E',
  [OrderStatusType.AWAITING]: '#FED925',
};

export const OrderStatusTypeText = {
  [OrderStatusType.AWAITING]: 'Aguardando',
  [OrderStatusType.PRE_APPROVED]: 'Pré Aprovado',
  [OrderStatusType.REFUSED]: 'Recusado',
};

export type Results = {
  id: number,
  firstName: string,
  lastName: string,
  gpId: string,
  hiringDate: string,
  name: string,
  brand: string,
  year: number,
  yearModel: number,
  transmission: string,
  inspectionCode: string,
  licensePlate: string,
  orderId: number,
  position: number,
  status: OrderStatusType,
  createdDate: string,
  level: string,
  fullName: string,
}

export interface IOrder {
  results: Results[];
  total: number;
}